export const REPORTED_ISSUES_QUERY = `
  query ReportedIssues {
    reportedIssues {
      id
      issueNumber
      issueType
      relatedProject
      title
      priority
      status
      attachmentFileNames
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
    }
  }
`;

export const REPORTED_MY_ISSUES_QUERY = `
  query ReportedMyIssues {
    reportedMyIssues {
      id
      issueNumber
      issueType
      relatedProject
      title
      priority
      status
      attachmentFileNames
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const REPORTED_ISSUE_QUERY = `
  query ReportedIssue($id: String!) {
    reportedIssue(id: $id) {
      id
      issueNumber
      issueType
      relatedProject
      title
      priority
      status
      description
      attachmentFileNames
      submittedByUserId
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_REPORTED_ISSUE_MUTATION = `
  mutation UpdateReportedIssue($input: UpdateReportedIssueInput!) {
    updateReportedIssue(input: $input) {
      id
      issueNumber
      issueType
      relatedProject
      title
      priority
      status
      description
      attachmentFileNames
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const REPORTED_ISSUE_MESSAGES_QUERY = `
  query ReportedIssueMessages($issueId: String!) {
    reportedIssueMessages(issueId: $issueId) {
      id
      issueId
      senderUserId
      senderName
      senderRole
      content
      attachmentFileNames
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_REPORTED_ISSUE_MESSAGE_MUTATION = `
  mutation CreateReportedIssueMessage($input: CreateReportedIssueMessageInput!) {
    createReportedIssueMessage(input: $input) {
      id
      issueId
      senderUserId
      senderName
      senderRole
      content
      attachmentFileNames
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_REPORTED_ISSUE_MUTATION = `
  mutation CreateReportedIssue($input: CreateReportedIssueInput!) {
    createReportedIssue(input: $input) {
      id
      issueNumber
      status
      createdAt
    }
  }
`;
